/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';
import { VerificationMethodMultikeyType } from './VerificationMethodMultikeyType';

export const VerificationMethodMultikey: core.serialization.ObjectSchema<
    serializers.VerificationMethodMultikey.Raw,
    Truvity.VerificationMethodMultikey
> = core.serialization.object({
    context: core.serialization.property('@context', core.serialization.list(core.serialization.string()).optional()),
    controller: core.serialization.string(),
    id: core.serialization.string(),
    publicKeyMultibase: core.serialization.string(),
    type: VerificationMethodMultikeyType,
});

export declare namespace VerificationMethodMultikey {
    export interface Raw {
        '@context'?: string[] | null;
        controller: string;
        id: string;
        publicKeyMultibase: string;
        type: VerificationMethodMultikeyType.Raw;
    }
}
